import { useEffect } from "react";

export default function ScrollReveal() {
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add("revealed");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: "0px 0px -30px 0px" });

    const tag = () => {
      document.querySelectorAll(".glass-card:not(.reveal-tagged)").forEach(el => {
        el.classList.add("reveal-tagged");
        if (el.closest("header") || el.closest("[data-testid$='-overlay']") || el.closest(".menu-drawer")) return;
        el.classList.add("reveal-init");
        io.observe(el);
      });
    };
    tag();
    const mo = new MutationObserver(tag);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, []);
  return null;
}
